import axios from '../axiosInstance';
import { createCrudApi } from '../createCrudApi';

export type DeceasedGetParams = {
  limit?: number;
  offset?: number;
};

export type DeceasedListItem = {
  id: number;
  birth_id: string | null;
  insurance_number: string | null;
  is_unknown: boolean;
  title_before: string;
  first_name: string;
  last_name: string;
  title_after: string;
  gender: number | null;
  gender_display: string;
  date_of_birth: string | null;
  age_years: number | null;
  insurance_company: number | null;
  date_of_death: string | null;
  residence_address: string;
  contact_address: string;
  note: string;
  latest_autopsy_protocol_id: string;
  latest_autopsy_protocol_number: string;
  latest_autopsy_protocol_year: string;
  latest_autopsy_protocol_pathologist: string;
  latest_autopsy_protocol_status: string;
};

export type Deceased = {
  id: number;
  birth_id: string | null;
  insurance_number: string | null;
  is_unknown: boolean;
  title_before: string | null;
  first_name: string;
  last_name: string;
  title_after: string | null;
  gender: number | null;
  date_of_birth: string | null;
  date_of_death: string | null;
  age_years: number | null;
  insurance_company: number | null;
  residence_address: string;
  contact_address: string;
  residence_ruian_address: number | null;
  contact_ruian_address: number | null;
  note: string;
  baby_age: string | null;
};

export type DeceasedFormData = {
  birth_id?: string;
  insurance_number?: string | null;
  is_unknown?: boolean;
  title_before?: string;
  first_name?: string;
  last_name?: string;
  title_after?: string;
  gender?: number;
  date_of_birth?: string;
  date_of_death?: string;
  age_years?: number;
  insurance_company?: number;
  residence_address?: string;
  contact_address?: string;
  residence_ruian_address?: number | null;
  contact_ruian_address?: number | null;
  note?: string;
};

export type DeceasedIdentifyResponse = {
  status: 'existing' | 'new';
  deceased: Deceased;
};

export const DeceasedApi = () => ({
  ...createCrudApi<Deceased, DeceasedFormData, DeceasedGetParams>('/v1/deceased/'),

  identify: (data: DeceasedFormData) =>
    axios.post<DeceasedIdentifyResponse>('/v1/deceased/identify/', data)
});
